import { WSService } from "../../../utils/WSService";
import type { resourceEventHistoryApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/resource-events");

export async function listResourceEvents(
  query?: resourceEventHistoryApiSpec.operations["listResourceEvents"]["parameters"]["query"]
): Promise<resourceEventHistoryApiSpec.IResourceEvent[]> {
  const { data } = await service.get("", { params: query });
  return data;
}
